module.exports = __webpack_public_path__ + "static/img/cont32_05.6c4e490.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/cont32_05.jpg
// module id = B1vw
// module chunks = 0